"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioOutputChooser = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _chime = require("@studio/chime");
var _constants = require("@studio/constants");
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledSelect = _styledComponents["default"].select(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: #6e7582;\n  border: 1px solid #dfe3ec;\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin: 10px 0px;\n"])));
var AudioOutputChooser = exports.AudioOutputChooser = function AudioOutputChooser(_ref) {
  var meetingSession = _ref.meetingSession,
    onAudioOutputChanged = _ref.onAudioOutputChanged,
    selectedAudioOutputId = _ref.selectedAudioOutputId;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    devices = _useState2[0],
    setDevices = _useState2[1];
  (0, _chime.useAudioVideoDevice)({
    meetingSession: meetingSession,
    setDevices: setDevices,
    onDeviceChanged: onAudioOutputChanged,
    selectedDeviceId: selectedAudioOutputId,
    deviceType: _constants.AUDIO_OUTPUT
  });
  return /*#__PURE__*/_react["default"].createElement(StyledSelect, {
    onChange: function onChange(event) {
      return onAudioOutputChanged(event.target.value);
    }
  }, devices.map(function (_ref2) {
    var deviceId = _ref2.deviceId,
      label = _ref2.label;
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: deviceId,
      value: deviceId,
      selected: deviceId === selectedAudioOutputId
    }, label);
  }));
};
AudioOutputChooser.defaultProps = {
  selectedAudioOutputId: ''
};
AudioOutputChooser.propTypes = {
  meetingSession: _propTypes.object.isRequired,
  onAudioOutputChanged: _propTypes.func.isRequired,
  selectedAudioOutputId: _propTypes.string
};